import React, { useContext, useState } from "react"
import { GlobalStateContext } from "./providers/GlobalStateProvider.jsx"
import { Popover } from "@shopify/polaris"
import { auth } from "../firebase.js"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { usePostHog } from "posthog-js/react"

export const AccountSelector = () => {
	const posthog = usePostHog()
	const { state, dispatch } = useContext(GlobalStateContext)
	const navigate = useNavigate()
	const [showPopover, setShowPopover] = useState(false)
	const { t } = useTranslation()

	const logout = () => {
		auth.signOut()
		posthog?.reset()
	}

	return (
		<div
			style={{
				background: "#d4d8ff",
				borderRadius: "5rem",
				padding: "0.15rem 0.7rem",
				position: "relative",
				zIndex: "2",
			}}
		>
			<div
				onClick={() => setShowPopover(!showPopover)}
				style={{
					color: "#0d45dd",
					cursor: "pointer",
					verticalAlign: "middle",
					height: "1.75rem",
					display: "flex",
					gap: "0.3rem",
					alignItems: "center",
				}}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1.25rem"
					height="1.25rem"
					viewBox="0 0 24 24"
				>
					<path
						fill="currentColor"
						d="M5.85 17.1q1.275-.975 2.85-1.538T12 15q1.725 0 3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4Q8.675 4 6.337 6.337T4 12q0 1.475.488 2.775T5.85 17.1ZM12 13q-1.475 0-2.488-1.012T8.5 9.5q0-1.475 1.012-2.488T12 6q1.475 0 2.488 1.012T15.5 9.5q0 1.475-1.012 2.488T12 13Zm0 9q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"
					></path>
				</svg>
				<span
					className="email"
					style={{ fontSize: "0.875rem", fontWeight: "500" }}
				>
					{state.userEmail}
				</span>

				<Popover
					active={showPopover}
					onClose={() => setShowPopover(false)}
					preferredPosition="below"
					preferredAlignment="right"
					zIndexOverride="510"
					activator={
						<div
							style={{
								cursor: "pointer",
								background: "transparent",
								display: "flex",
								alignItems: "center",
							}}
							onClick={() => setShowPopover(!showPopover)}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="1.25rem"
								height="1.25rem"
								viewBox="0 0 24 24"
							>
								<path
									fill="currentColor"
									d="m12 15l-5-5h10l-5 5Z"
								></path>
							</svg>
						</div>
					}
				>
					<div
						style={{
							padding: "0.2rem",
							display: "flex",
							flexDirection: "column",
							gap: "0.2rem",
						}}
					>
						<div
							onClick={() => navigate("/account")}
							className="my-account-button"
							style={{
								padding: "0.3rem 0.5rem",
								display: "flex",
								alignItems: "center",
								gap: "0.3rem",
								borderRadius: "0.3rem",
								cursor: "pointer",
								paddingRight: "1rem",
							}}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="0.9rem"
								height="0.9rem"
								viewBox="0 0 24 24"
							>
								<circle
									cx="10"
									cy="8"
									r="4"
									fill="currentColor"
								></circle>
								<path
									fill="currentColor"
									d="M10.67 13.02c-.22-.01-.44-.02-.67-.02c-2.42 0-4.68.67-6.61 1.82c-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 0 1-.59-6.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01l-1-1.73l-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49l-1 1.73l1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01l1 1.73l1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49l1-1.73l-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2z"
								></path>
							</svg>
							<span
								style={{
									fontSize: "0.8rem",
									fontWeight: "500",
								}}
							>
								{t("account.my_account")}
							</span>
						</div>

						<div
							className="logout-button"
							onClick={logout}
							style={{
								padding: "0.3rem 0.5rem",
								display: "flex",
								alignItems: "center",
								gap: "0.3rem",
								borderRadius: "0.3rem",
								cursor: "pointer",
							}}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="0.9rem"
								height="0.9rem"
								viewBox="0 0 24 24"
							>
								<path
									fill="currentColor"
									d="m2 12l5 4v-3h9v-2H7V8z"
								></path>
								<path
									fill="currentColor"
									d="M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051s2.051 3.08 2.051 4.95s-.729 3.628-2.051 4.95s-3.08 2.051-4.95 2.051s-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
								></path>
							</svg>
							<span
								style={{
									fontSize: "0.8rem",
									fontWeight: "500",
								}}
							>
								{t("common.log_out")}
							</span>
						</div>
					</div>
				</Popover>
			</div>
			<style>{`
				.my-account-button {
					color: #555;
				}
				.my-account-button:hover {
					background: #e7e7e7;
					color: #585858;
				}
				.logout-button {
					color: #555;
				}
				.logout-button:hover {
					background: #fecccc;
					color: #9e1010;
				}
				.email {
					display: block;
				}
				@media (max-width: 1020px) {
					.email {
						display: none;
					}
				}
			`}</style>
		</div>
	)
}
